import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIERS } from "./constants";

const {
  ROLES_MGMT,
  USER_ROLES_MGMT,
  USERS_IDENTIFIER,
  LOADER_IDENTIFIER,
  USER_DETAILS,
  SELECTABLE_ROLES,
  USER_ROLES,
  LIST_IDENTIFIER,
  SELECTED_USER,
  RESPONSE_STATE,
  ADDED_ROLES,
  DELETED_ROLES,
  ROLES_IDENTIFIER,
  VISIBILITY_CONES_IDENTIFIER,
  ROLE_USERS_MGMT,
  SELECTED_ROLE,
  SELECTED_USERS,
  USERS_LOADER_IDENTIFIER,
  SELECTED_USERS_LOADER_IDENTIFIER,
  ROLE_TO_EDIT,
  VISIBILITY_CONE_TO_EDIT,
  FAILURES,
  ROLES_NEW_VISIBILITY_CONE,
} = STATE_IDENTIFIERS;

export default {
  [ROLES_MGMT]: {
    [FAILURES]: [],
    [ROLE_TO_EDIT]: {},
    [VISIBILITY_CONE_TO_EDIT]: {},
    [RESPONSE_STATE]: IResponseState.PENDING,
    [ROLES_IDENTIFIER]: {
      [LOADER_IDENTIFIER]: false,
      [LIST_IDENTIFIER]: [],
    },
    [VISIBILITY_CONES_IDENTIFIER]: {
      [LOADER_IDENTIFIER]: false,
      [LIST_IDENTIFIER]: [],
    },
    [ROLES_NEW_VISIBILITY_CONE]: {
      [LOADER_IDENTIFIER]: false,
      [LIST_IDENTIFIER]: [],
    },
  },
  [ROLE_USERS_MGMT]: {
    [USERS_LOADER_IDENTIFIER]: false,
    [SELECTED_USERS_LOADER_IDENTIFIER]: false,
    [RESPONSE_STATE]: IResponseState.PENDING,
    [SELECTED_ROLE]: {},
    [USERS_IDENTIFIER]: [],
    [SELECTED_USERS]: [],
  },
  [USER_ROLES_MGMT]: {
    [USERS_IDENTIFIER]: {},
    [LOADER_IDENTIFIER]: false,
  },
  [USER_DETAILS]: {
    [FAILURES]: [],
    [RESPONSE_STATE]: IResponseState.PENDING,
    [SELECTED_USER]: {},
    [SELECTABLE_ROLES]: {
      [LOADER_IDENTIFIER]: false,
      [LIST_IDENTIFIER]: [],
    },
    [USER_ROLES]: {
      [LOADER_IDENTIFIER]: false,
      [LIST_IDENTIFIER]: [],
    },
    [ADDED_ROLES]: [],
    [DELETED_ROLES]: [],
  },
};
